module.exports = "1. 这是说明信息<br/>\n2. 这是说明信息\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./static/specTracker/specTracker-10.txt
// module id = i0u+
// module chunks = 2